import React from "react";
import { FilterPageIcon } from "@/shared/icons";
import { DropdownMenu } from "@/common/DropdownMenu";
import type { MenuSorterOptions } from "../MenuSorterList";
import { MenuSorterList } from "../MenuSorterList";
import styles from "../styles.module.scss";

type Props = {
  onMenuChange: (sortType: MenuSorterOptions) => void;
  sorterMenuValue: MenuSorterOptions;
};

export const MenuSorterDropdown: React.FC<Props> = ({ onMenuChange, sorterMenuValue }) => {
  return (
    <DropdownMenu
      iconType="secondary"
      content={<MenuSorterList sorterMenuValue={sorterMenuValue} onMenuChange={onMenuChange} />}
    >
      <FilterPageIcon className={styles["menu-icon"]} />
    </DropdownMenu>
  );
};
